import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { HttpHeadersService } from 'src/app/core/shared-service/http-headers.service';
import { environment } from 'src/environments/environment';
import { GcpToken } from './services.model';

@Injectable({
  providedIn: 'root',
})
export class ServicePageService {
  private gcpToken: GcpToken;
  private getTokenPromise: Promise<any> | undefined;
  constructor( private _http: HttpClient, private _httpHeaderService: HttpHeadersService){
  }

  private _serviceEquipmentInfo = new Subject<any>();
  serviceEquipmentInfoSubscriber = this._serviceEquipmentInfo.asObservable();

  async getEquipmentRotations(facilityIds: string) {
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/rotation?facility_id=${facilityIds}`, { headers }).toPromise();
  }

  async getHistoryData(facilityIds: string) {
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/history?facilityId=${facilityIds}`, { headers }).toPromise();
  }

  async getEquipmentRotationRefreshDate() {
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/rotation/refreshDate`, { headers }).toPromise();
  }

  async updateEquipmentRotations(payload:any,facility:any){
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    const data = await this._http.post(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/rotation`, payload, { headers }).toPromise();
    this.getCounts(facility);
    return data;
  }

  async getInspectBelts(facilityId: string) {    
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/inspect_belts?facility_id=${facilityId}`, { headers }).toPromise();    
  }

  async updateInspectBelts(payload: any,facility:any) {    
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    const data = await this._http.post(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/inspect_belts`, payload, { headers }).toPromise();
    this.getCounts(facility);
    return data;
  }

  async getServiceRequests(facilityId: string) {    
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/service_requests?facility_id=${facilityId}`, { headers }).toPromise();
    
  }

  async getWorkOrders(facilityId: string) {    
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/work_orders?facility_id=${facilityId}`, { headers }).toPromise();
  }

  async getErrorCodes(facilityId: string) {    
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/error_codes/by_facility?facility_id=${facilityId}`, { headers }).toPromise();
  }

  async updateErrorCodes(payload: any,facility: any) {    
    const headers = await this.bearerGcpHttpAuthorizationHeader();  
    const data = await this._http.post(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/error_codes`, payload,{ headers }).toPromise();
    this.getCounts(facility);
    return data;
  }

  async getCounts(facility:any) {
    try {
      const headers = await this.bearerGcpHttpAuthorizationHeader();
      const data = await this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/items?facility_id=${facility.facilityId}&is_planetFitness=${facility.summary.isPlanetFitness === "true"?true:false}`, { headers }).toPromise();
      this._serviceEquipmentInfo.next(data);
    } catch (error) {
      console.error('API failed.')
    }
  }


  async getJobOrder(facilityId: string, orderId: string) {
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/work_orders/detail?facility_id=${facilityId}&id=${orderId}`,
      { headers }).toPromise();
  }

  async addJobOrder(payload: any) {
    const headers = await this.bearerGcpHttpAuthorizationHeaderWithoutContentType();
    headers.set('Content-Type', 'multipart/form-data');
    return this._http.post(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/work_orders`, payload,
      { headers }).toPromise();
  }

  async updateJobOrder(payload: any) {
    const headers = await this.bearerGcpHttpAuthorizationHeaderWithoutContentType();
    return this._http.put(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/work_orders`, payload,
      { headers }).toPromise();
  }

  async deleteJobOrder(facilityId: string, orderId: string, email: string) {
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.delete(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/work_orders?facility_id=${facilityId}&id=${orderId}&email=${email}`,
      { headers }).toPromise();
  }

  async getAssets(facilityId: string, type: string) {
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.get(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/asset?facility_id=${facilityId}&type=${type}`,
      { headers }).toPromise();
  }

  async addComment(payload: any) {
    const headers = await this.bearerGcpHttpAuthorizationHeader();
    return this._http.post(`${environment.gcpBasePath}/servicenotices-gcp/api/v1/maintenance/work_orders/comments`, payload,
      { headers }).toPromise();
  }

  async getGcpToken() {
    try {
      if(this.getTokenPromise) await this.getTokenPromise;
      else {
        if(this.gcpToken?.expiredTimeInMilli > Date.now()) return;
        const headers = this._httpHeaderService.bearerHttpAuthorizationHeader();
        this.getTokenPromise = this._http.get(`${environment.servicePath}/lfuser/get_gcp_token`, { headers }).toPromise();
        this.gcpToken = await this.getTokenPromise;
        this.getTokenPromise = undefined;
        if (Number.isNaN(this.gcpToken.expiredTimeInMilli)) this.gcpToken.expiredTimeInMilli = Number.parseInt(this.gcpToken.expiredTimeInMilli.toString());
      }
    } catch (error) {
      this.getTokenPromise = undefined;
      throw error;
    }
  }

  private async bearerGcpHttpAuthorizationHeader() {
    await this.getGcpToken();
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', "Bearer " + this.gcpToken.token);
    headers = headers.append('X-Halo-Auth', this.gcpToken.token??'');
    headers = headers.append('Content-Type', 'application/json');
    return headers;
  }

  private async bearerGcpHttpAuthorizationHeaderWithoutContentType() {
    await this.getGcpToken();
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', "Bearer " + this.gcpToken.token);
    headers = headers.append('X-Halo-Auth', this.gcpToken.token??'');
    return headers;
  }
}
